import React, { createContext, useState, useEffect, useRef } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import { getUserData } from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);

  // Track whether we've seen a logged-in user so we can detect token loss (expiry) vs normal logout
  const wasLoggedIn = useRef(false);

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(auth, async (authUser) => {
      if (authUser) {
        wasLoggedIn.current = true;
        setSessionExpired(false);
        setCurrentUser(authUser);
        const result = await getUserData(authUser.uid);
        if (result.success) {
          setUserData(result.data);
        } else {
          setError(result.error);
        }
      } else {
        // If we were logged in and now we're not, show the session expired modal
        if (wasLoggedIn.current) {
          setSessionExpired(true);
        }
        wasLoggedIn.current = false;
        setCurrentUser(null);
        setUserData(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const dismissExpired = () => setSessionExpired(false);

  const value = {
    currentUser,
    userData,
    loading,
    error,
    isAuthenticated: !!currentUser,
    sessionExpired,
    dismissExpired,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
